import React from 'react';

const BestSellerIcon: React.FC = () => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_7794_54782)'>
        <path
          d='M9.99911 0.904541L13.5208 6.05704L19.5099 7.81454L15.6974 12.7562L15.8766 18.9945L9.99911 16.8962L4.12161 18.9945L4.30078 12.7562L0.488281 7.81454L6.47745 6.05704L9.99911 0.904541ZM9.99911 3.85787L7.51745 7.48954L3.29661 8.72704L5.98412 12.2087L5.85661 16.6045L9.99911 15.1262L14.1408 16.6045L14.0141 12.2087L16.7008 8.72704L12.4808 7.48954L9.99911 3.85787ZM8.33245 10.4879C8.33245 10.9299 8.50804 11.3538 8.8206 11.6664C9.13316 11.9789 9.55709 12.1545 9.99911 12.1545C10.4411 12.1545 10.8651 11.9789 11.1776 11.6664C11.4902 11.3538 11.6658 10.9299 11.6658 10.4879H13.3324C13.3324 11.3719 12.9813 12.2198 12.3561 12.8449C11.731 13.47 10.8832 13.8212 9.99911 13.8212C9.11506 13.8212 8.26721 13.47 7.64209 12.8449C7.01697 12.2198 6.66578 11.3719 6.66578 10.4879H8.33245Z'
          fill='#C7C6CF'
        />
      </g>
      <defs>
        <clipPath id='clip0_7794_54782'>
          <rect
            width='20'
            height='20'
            fill='white'
            transform='translate(0 0.487793)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BestSellerIcon;
